import { render, staticRenderFns } from "./salesReturn.vue?vue&type=template&id=07dea4b6&scoped=true&"
import script from "./salesReturn.vue?vue&type=script&lang=js&"
export * from "./salesReturn.vue?vue&type=script&lang=js&"
import style0 from "./salesReturn.vue?vue&type=style&index=0&id=07dea4b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dea4b6",
  null
  
)

export default component.exports